// extracted by mini-css-extract-plugin
module.exports = {"page_row":"NewVehicles_page_row__2kdUN","page_sub_section":"NewVehicles_page_sub_section__29kTU","page_section":"NewVehicles_page_section__3cgDn"};